import Repository from "./Repository";

const formDataConfig = {
    headers: { "Content-Type" : "multipart/form-data" }
};

const createBrandGuideline = "/marcom/studio/addBrandGuidelines";

export default {
    createBrandGuidelines(payload) {
    return Repository.post(`${createBrandGuideline}`, payload);
    },
}